import { render, staticRenderFns } from "./tableNewspaperBulky.vue?vue&type=template&id=f01c487e&scoped=true&"
import script from "./tableNewspaperBulky.vue?vue&type=script&lang=js&"
export * from "./tableNewspaperBulky.vue?vue&type=script&lang=js&"
import style1 from "./tableNewspaperBulky.vue?vue&type=style&index=1&id=f01c487e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01c487e",
  null
  
)

export default component.exports